var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2781 6.45093L17.3572 6.64233L17.5486 6.72241L21.1462 8.21069L19.658 11.8083L19.5789 11.9998L19.658 12.1912L21.1462 15.7888L17.5486 17.2781L17.3572 17.3572L17.2781 17.5486L15.7888 21.1462L12.1912 19.658L11.9998 19.5789L11.8083 19.658L8.21069 21.1462L6.72241 17.5486L6.64233 17.3572L6.45093 17.2781L2.85229 15.7888L4.34155 12.1912L4.42065 11.9998L4.34155 11.8083L2.85229 8.21069L6.45093 6.72241L6.64233 6.64233L6.72241 6.45093L8.21069 2.85229L11.8083 4.34155L11.9998 4.42065L12.1912 4.34155L15.7888 2.85229L17.2781 6.45093Z",
    fill: "#0087FE",
    stroke: "#0087FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.dd57f1d863d48ed84ebc9f424a183fa5.svg";
export { ForwardRef as ReactComponent };